module.exports = __webpack_public_path__ + "static/media/13.13f26b25.png";